<template>
  <PhonelineSetupProvider v-if="isNeeded" @empty-response="emit('empty')">
    <slot />
  </PhonelineSetupProvider>

  <slot v-else />
</template>

<script setup lang="ts">
import PhonelineSetupProvider from './components/PhonelineSetupProvider/PhonelineSetupProvider.vue'

defineProps<{
  isNeeded: boolean
}>()

const emit = defineEmits<{
  (e: 'empty'): void
}>()
</script>
